import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatRM, STATUSES, jobPic, statusColor } from "@/lib/api";
import { useAutoRefresh } from "@/hooks/useAutoRefresh";
import { StatusBadge, AgentBadge } from "@/components/StatusBadge";
import { Countdown } from "@/components/Countdown";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Flame } from "lucide-react";

const BOARD_STATUSES = STATUSES.filter(s => !["Collected", "Cancelled"].includes(s));

export default function ProductionBoard() {
  const [jobs, setJobs] = useState([]);
  const nav = useNavigate();
  const { hasPerm } = useAuth();

  const load = () => api.get("/jobs").then((r) => setJobs(r.data));
  useEffect(() => { load(); }, []);
  useAutoRefresh(load, 20000);

  return (
    <div className="space-y-4" data-testid="production-board">
      <div>
        <h1 className="text-2xl font-display font-bold">Production Board</h1>
        <p className="text-sm text-muted-foreground">Kanban board by job status</p>
      </div>

      <div className="flex gap-3 overflow-x-auto pb-4">
        {BOARD_STATUSES.map((s) => {
          const col = jobs.filter((j) => j.status === s);
          return (
            <div key={s} className="kanban-col flex-shrink-0" style={{ borderTop: `4px solid ${statusColor(s)}` }} data-testid={`kanban-col-${s.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="mb-2 flex items-center justify-between">
                <StatusBadge status={s} />
                <span className="text-xs font-mono text-muted-foreground">{col.length}</span>
              </div>
              <div className="space-y-2 min-h-[100px]">
                {col.map((j) => (
                  <Card
                    key={j.id}
                    onClick={() => nav(`/jobs/${j.id}`)}
                    className="p-3 cursor-pointer hover:shadow-md transition"
                    data-testid={`kanban-card-${j.job_number}`}
                  >
                    <div className="flex items-center gap-1 mb-1">
                      {j.priority === "urgent" && <Flame className="w-3 h-3 text-orange-500" />}
                      <div className="font-mono font-semibold text-xs">{j.job_number}</div>
                      <AgentBadge job={j} className="ml-auto" />
                    </div>
                    <Countdown job={j} className="mb-1" />
                    <div className="text-sm font-medium truncate">{j.customer_name}</div>
                    <div className="text-xs text-muted-foreground truncate">{j.product} × {j.quantity}</div>
                    <div className="mt-2 flex items-center justify-between text-xs">
                      <span className="font-mono">{hasPerm("sales") ? formatRM(j.total_price) : ""}</span>
                      <span className="text-muted-foreground">{jobPic(j)}</span>
                    </div>
                  </Card>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
